<template>
  <loading-container :loading="false">
    <span v-if="summary.favorite">
      <span class="mytooltip tooltip-effect-5 watchlist-section text-blue">
        <i :class="getFeatureIcons('unwatchlist')" @click="() => onRemoveWatchlist({code: summary.code, page : 'overview'})"></i>
        <span class="tooltip-content clearfix">
          <span class="tooltip-text"> {{ $t('messages.watchlist_remove_code')}} </span>
        </span>
      </span>
    </span>
    <span v-else>
      <span class="mytooltip tooltip-effect-5 watchlist-section text-blue">
        <i :class="getFeatureIcons('watchlist')" @click="() => onAddToWatchlist({code: summary.code, page : 'overview'})"></i>
        <span class="tooltip-content clearfix">
          <span class="tooltip-text"> {{ $t('messages.watchlist_add_code')}} </span>
        </span>
      </span>
    </span>
  </loading-container>
</template>
<script>
import LoadingContainer from "@/components/Misc/LoadingContainer";
import common from "../../libs/common";
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'AddWatchList',
  components: {
    LoadingContainer
  },
  props: ["status"],
  computed: {
    ...mapGetters({
      summary: "stock/summary",
      form: "stock/form",
    }),
  },
  methods: {
    ...mapActions({
      setField: "stock/setField",
      onRemoveWatchlist: "stock/onRemoveWatchlist",
      onAddToWatchlist: "stock/onAddToWatchlist",
    }),
    getFeatureIcons(feature) {
      return common.getFeatureIcons(feature);
    },
  }
}
</script>

<style scoped>
.watchlist-section {
  cursor: pointer;
  font-size: 16px;
}
</style>